import { ChipsideComponent } from "../chipside-component";

export class Breadcrumb extends ChipsideComponent {
	constructor() {
		super();

		this.description = this.getAttribute("description") ?? "Breadcrumb";
	}

	parsedCallback() {
		this.appendChild(document.createElementWithContents("nav", document.createElementWithContents("ol", [...this.children ?? []].map(x => document.createElementWithContents("li", x)), {
			className: "breadcrumb-list"
		}), { ariaLabel: this.description }));
	}
}